<template>
  左中右下
</template>

<script>
export default {
  name: 'HomeIndex'
}
</script>

<style lang="less" scoped>

</style>>
